import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

// Modelo intermedio (through) Modulo <-> StudyUnit.
// Guarda el contenido (texto enriquecido) y el estado de esa StudyUnit dentro del Módulo.
// NO agrupa actividades: las actividades cuelgan del Módulo (ver E7).
const state = {
    instructional_units: [],
    instructional_units_url: '/teaching/instructional-unit'
}

const getters = {
    [names.INSTRUCTIONAL_UNITS]: state => {
        if (!get.store.state.user) return [];
        return state.instructional_units
            .filter((x) => x.school == get.store.state.user.school)
            .sort(function (a, b) {
                if (a.order > b.order) return 1;
                if (a.order < b.order) return -1;
                return 0;
            });
    },
    [names.INSTRUCTIONAL_UNIT]: (state,) => id => {
        return state.instructional_units.find(x => x.id == id);
    },
}

const mutations = {
    [names.MUTATE_INSTRUCTIONAL_UNITS]: (state, instructional_units) => {
        instructional_units.forEach(element => {
            let index = state.instructional_units.findIndex(x => x.id == element.id);
            if (index != -1) state.instructional_units.splice(index, 1, element);
            else state.instructional_units.push(element);
        });
        state.instructional_units.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_INSTRUCTIONAL_UNIT]: (state, instructional_unit) => {
        let index = state.instructional_units.findIndex(x => x.id == instructional_unit.id);
        if (index != -1) state.instructional_units.splice(index, 1, instructional_unit);
        else state.instructional_units.push(instructional_unit);
        state.instructional_units.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_DELETE_INSTRUCTIONAL_UNIT]: (state, instructional_unit_id) => {
        let index = state.instructional_units.findIndex(x => x.id == instructional_unit_id);
        if (index != -1) state.instructional_units.splice(index, 1);
    },
}

const actions = {
    [names.FETCH_INSTRUCTIONAL_UNIT]: ({
        commit,
        state
    }, instructional_unit_id) => {
        return new Promise((resolve, reject) => {
            const instance = state.instructional_units.find(x => x.id == instructional_unit_id);
            if (instance) {
                resolve(instance);
                return;
            }
            restful.Get(`${state.instructional_units_url}/${instructional_unit_id}/`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_UNIT, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    /**
     * payload: { module_id, instructional_design_id, force }
     * Con `instructional_design_id` trae de una vez las unidades de todos los
     * Móduloes del diseño (evita una llamada por Módulo).
     */
    [names.FETCH_INSTRUCTIONAL_UNITS]: ({
        commit,
        state,
    }, payload = {}) => {
        const {
            module_id = null,
            instructional_design_id = null,
            force = false,
        } = payload;
        return new Promise((resolve, reject) => {
            if (!force && module_id != null) {
                const cached = state.instructional_units.filter(x => x.module == module_id);
                if (cached.length > 0) {
                    resolve(cached);
                    return;
                }
            }
            let query = '';
            if (module_id != null) query = `?module=${module_id}`;
            else if (instructional_design_id != null) query = `?instructional_design=${instructional_design_id}`;
            restful.GetAll(`${state.instructional_units_url}/${query}`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_UNITS, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.POST_INSTRUCTIONAL_UNIT]: ({
        commit,
        state
    }, instructional_unit) => {
        return new Promise((resolve, reject) => {
            restful.Post(`${state.instructional_units_url}/`, instructional_unit)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_UNIT, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.UPDATE_INSTRUCTIONAL_UNIT]: ({
        commit,
        state
    }, instructional_unit) => {
        return new Promise((resolve, reject) => {
            restful.Put(`${state.instructional_units_url}/${instructional_unit.id}/`, instructional_unit)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_UNIT, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // payload: { instructional_unit_id, item }
    [names.PATCH_INSTRUCTIONAL_UNIT]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.instructional_units_url}/${payload.instructional_unit_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_UNIT, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.DELETE_INSTRUCTIONAL_UNIT]: ({
        commit,
        state
    }, instructional_unit_id) => {
        return new Promise((resolve, reject) => {
            restful.Delete(`${state.instructional_units_url}/${instructional_unit_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_INSTRUCTIONAL_UNIT, instructional_unit_id);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
